(function(){
    'use strict'

    angular.module('app.nacionalidades')
    .factory('NacionalidadesService', NacionalidadesService);

    NacionalidadesService.$inject = ['$http', '$q', 'apiSettings'];

    function NacionalidadesService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/nacionalidades';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(nacionalidadId){

            var url = apiSettings.apiBaseUrl + 'api/nacionalidades/' + nacionalidadId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(nacionalidad){

            nacionalidad.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/nacionalidades',  
                method: 'POST',  
                data: nacionalidad
            });  
            return response;
        };

        function update(nacionalidad){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/nacionalidades',  
                method: 'PUT',  
                data: nacionalidad
            });  
            return response;
        };

        function remove(nacionalidad){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/nacionalidades',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: nacionalidad
            });  
            return response;
        };

    };

})();